export default function getFilterWithCol(filter, col) {
  return [filter[0], { ...filter[1], col: { xs: 24, lg: col } }];
}
